import { createApi } from '@reduxjs/toolkit/query/react';
import type { PelnomocnikListDto, PelnomocnikDetailDto, PaginatedParams } from '@/types';
import { baseQueryWithRetry } from './baseQuery';
import { TAG_PELNOMOCNIK } from '@/store/tagTypes';

export const pelnomocnicyApi = createApi({
  reducerPath: 'pelnomocnicyApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: [TAG_PELNOMOCNIK],
  endpoints: (builder) => ({
    listPelnomocnicy: builder.query<PelnomocnikListDto, PaginatedParams | void>({
      query: (params) => ({
        url: '/pelnomocnicy',
        params: params
          ? {
              page: params.page?.toString(),
              pageSize: params.pageSize?.toString(),
            }
          : undefined,
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map(({ id }) => ({ type: TAG_PELNOMOCNIK, id })),
              { type: TAG_PELNOMOCNIK, id: 'LIST' },
            ]
          : [{ type: TAG_PELNOMOCNIK, id: 'LIST' }],
    }),

    getPelnomocnik: builder.query<PelnomocnikDetailDto, string>({
      query: (id) => `/pelnomocnicy/${id}`,
      providesTags: (_result, _error, id) => [{ type: TAG_PELNOMOCNIK, id }],
    }),
  }),
});

export const {
  useListPelnomocnicyQuery,
  useGetPelnomocnikQuery,
} = pelnomocnicyApi;
